// extracted by mini-css-extract-plugin
export default {"rowCotainer":"ListRow_rowCotainer__bg3GR","textareaAutosize":"ListRow_textareaAutosize__NZF-k","deleteIcon":"ListRow_deleteIcon__BQae+"};